import React from "react";
import { ORG_CONFIGS } from "../theme/org-configs.js";

export function OrgPickerScreen({ onSelect }) {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f4f1ec', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ maxWidth: '520px', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: '700', color: '#08314d', fontFamily: "'Montserrat', -apple-system, sans-serif" }}>Novo Navigator</h1>
          <p style={{ margin: 0, fontSize: '14px', color: '#3d6380', fontFamily: "'Montserrat', -apple-system, sans-serif" }}>Select your organization to get started</p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {Object.values(ORG_CONFIGS).map(org => (
            <div key={org.id} onClick={() => onSelect(org.id)} style={{
              backgroundColor: '#fff', border: '1px solid #dde5ed', borderRadius: '12px', padding: '18px 22px',
              cursor: 'pointer', transition: 'all 0.15s ease', display: 'flex', alignItems: 'center', gap: '16px',
              boxShadow: '0 1px 3px rgba(8,49,77,0.06)',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = org.primary;
              e.currentTarget.style.boxShadow = '0 12px 20px rgba(8,49,77,0.12), 0 4px 8px rgba(8,49,77,0.06)';
              e.currentTarget.style.transform = 'translateY(-5px) rotate(-0.5deg)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = '#dde5ed';
              e.currentTarget.style.boxShadow = '0 1px 3px rgba(8,49,77,0.06)';
              e.currentTarget.style.transform = 'translateY(0) rotate(0deg)';
            }}
            >
              {org.logo ? (
                <div style={{ width: '96px', height: '96px', borderRadius: '12px', backgroundColor: '#fff', border: '1px solid #dde5ed', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' }}>
                  <img src={org.logoMark || org.logo} alt={org.abbreviation} style={{ height: '80px', width: '80px', objectFit: 'contain' }} />
                </div>
              ) : (
                <div style={{ width: '96px', height: '96px', borderRadius: '12px', backgroundColor: '#fff', border: '1px solid #dde5ed', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, padding: '12px' }}>
                  <svg viewBox="0 0 665.2 229.2" style={{ width: '100%', height: 'auto' }}>
                    <g><g>
                      <polygon fill="#08314d" points="17.1,211.8 17.1,46.2 8.3,46.2 8.3,220.8 316.7,220.8 316.7,211.8" />
                      <polygon fill="#08314d" points="648,16.9 648,182.6 656.9,182.6 656.9,8 348.5,8 348.5,16.9" />
                    </g><g>
                      <path fill="#08314d" d="M200.5,164.4h-17.7l-45.1-55.1-7.4-11.7h-0.2v66.8h-21V64.3h17.7l45.6,55.1 6.9,11.4h0.2V64.3h21V164.4z"/>
                      <path fill="#08314d" d="M274.9,165.7c-33.7,0-51.5-20.9-51.5-50.7 0-29.8 17.8-51.9 51.5-51.9 34,0 51.5,22.1 51.5,51.9C326.4,144.8,308.1,165.7,274.9,165.7z M274.9,81.9c-21.3,0-30.2,13.8-30.2,33.1 0,18.7 8.9,31.9 30.2,31.9 21.5,0 30.1-13.2 30.1-31.9C305,96.2,296.4,81.9,274.9,81.9z"/>
                      <path fill="#08314d" d="M444.4,64.3l-45.3,100.1h-18.7L335.1,64.3h23.4l28.2,64.3 3.1,10h0.2l3.2-10 28.2-64.3H444.4z"/>
                      <path fill="#08314d" d="M504.6,165.7c-33.7,0-51.5-20.9-51.5-50.7 0-29.8 17.8-51.9 51.5-51.9 34,0 51.5,22.1 51.5,51.9C556.1,144.8,537.8,165.7,504.6,165.7z M504.6,81.9c-21.3,0-30.2,13.8-30.2,33.1 0,18.7 8.9,31.9 30.2,31.9 21.5,0 30.1-13.2 30.1-31.9C534.7,96.2,526.1,81.9,504.6,81.9z"/>
                    </g></g>
                  </svg>
                </div>
              )}
              <div>
                <p style={{ margin: '0 0 2px 0', fontSize: '15px', fontWeight: '600', color: '#08314d', fontFamily: "'Montserrat', -apple-system, sans-serif" }}>{org.name}</p>
                {org.id !== 'novo' && <p style={{ margin: 0, fontSize: '12px', color: '#3d6380', fontFamily: "'Montserrat', -apple-system, sans-serif" }}>Partner organization</p>}
                {org.id === 'novo' && <p style={{ margin: 0, fontSize: '12px', color: '#3d6380', fontFamily: "'Montserrat', -apple-system, sans-serif" }}>Default — no partner affiliation</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
